import { render } from "./protectionPlanDetailCard.vue?vue&type=template&id=25825c7e"
import script from "./protectionPlanDetailCard.vue?vue&type=script&lang=js"
export * from "./protectionPlanDetailCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__